module.exports = __webpack_public_path__ + "static/img/rongyu6.81b367e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rongyu6.jpg
// module id = dDmp
// module chunks = 1